import React from 'react';

import StatusView from 'src/sections/statuses';

export default function StatusPage() {
  return <StatusView />;
}
